import { useEffect, useMemo } from "react";
import { useCollection, useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { query, collection, doc } from "firebase/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

const mapSchedule = (doc) => {
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    startDate: getDate(data.startDate),
  };
};

const mapPayment = (doc) => {
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    scheduleId: doc.ref.parent.parent.id,
    date: getDate(data.date),
  };
};

export const useSchedule = (scheduleId) => {
  const docRef = doc(db, "paymentSchedules", scheduleId);
  const [scheduleDoc, docLoading, docError] = useDocument(docRef);
  const [payments, paymentsLoading, paymentsError] = useCollection(
    query(collection(db, `paymentSchedules/${scheduleId}/payments`))
  );
  const loading = docLoading || paymentsLoading;
  const error = docError || paymentsError;
  useEffect(() => {
    if (docError) {
      console.error("Error reading schedule", docError);
    }
    if (paymentsError) {
      console.error("Error reading schedule payments", paymentsError);
    }
  }, [docError, paymentsError]);
  const schedule = useMemo(() => {
    if (!scheduleDoc || !payments) {
      return undefined;
    }
    const data = mapSchedule(scheduleDoc);
    return {
      ...data,
      payments: payments.docs
        .map(mapPayment)
        .sort((a, b) => a.number - b.number),
    };
  }, [scheduleDoc, payments]);
  return { schedule, loading, error };
};
